import ConfigPage from '../../configs/ConfigPage'
function MyPage(props: any) {
  const configPage = ConfigPage.createFromConfigPageServer(props.configPage)
  const MyPageTypeFn = configPage.getMyPageFn()
  return MyPageTypeFn(props)
}

export default MyPage
